import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommStarFillIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M11.9966 1.25C13.0459 1.25 13.8724 2.04253 14.4 3.11191L16.1621 6.66516C16.2155 6.77513 16.3421 6.92998 16.5326 7.07164C16.7228 7.21315 16.909 7.29121 17.0316 7.3118L20.2212 7.84613C21.3734 8.03973 22.339 8.60449 22.6526 9.5879C22.9658 10.5705 22.5068 11.5916 21.6783 12.4216L21.6775 12.4225L19.1996 14.9209C19.1014 15.0199 18.9914 15.2064 18.9224 15.4494C18.8539 15.6908 18.8478 15.9107 18.8788 16.0527L18.8793 16.0547L19.5882 19.1454C19.8822 20.4317 19.7848 21.7073 18.8776 22.3742C17.9672 23.0433 16.7232 22.7467 15.593 22.0736L12.603 20.289C12.4775 20.214 12.2618 20.1532 12.0016 20.1532C11.7432 20.1532 11.5231 20.2132 11.3893 20.291L11.3874 20.2921L8.40337 22.0732C7.27454 22.7487 6.03203 23.04 5.1216 22.3702C4.21498 21.7032 4.11263 20.43 4.4076 19.1447L5.11639 16.0547L5.11682 16.0527C5.1479 15.9107 5.14182 15.6908 5.07329 15.4494C5.00429 15.2064 4.89427 15.0199 4.79606 14.9209L2.31634 12.4206C1.49313 11.5906 1.0357 10.5704 1.34644 9.58925C1.65808 8.60525 2.62192 8.0398 3.77482 7.84606L6.96181 7.31219L6.96282 7.31202C7.07966 7.29175 7.26319 7.21456 7.45296 7.07268C7.6431 6.93054 7.77008 6.77535 7.82361 6.66516L7.8263 6.65967L9.58611 3.11097L9.58681 3.10957C10.1195 2.04108 10.9485 1.25 11.9966 1.25Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
